import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
// import html2pdf from 'html2pdf';

import { toPng, toJpeg, toSvg, toCanvas } from "html-to-image";
import { descargarArchivo } from '../../Services/ArchivosService';
// import download from 'download'



export const descargarImagen = (IdElement, nombreArchivo, setLoading = ()=>{},) => {
    setLoading(true);
    const element = document.getElementsByClassName(IdElement)[0];
    // html2canvas(element).then(canvas => {
    //     var link = document.createElement('a');
    //     link.href = canvas.toDataURL('image/jpeg', 1);
    //     link.download =nombreArchivo + '.jpeg';
    //     link.click();
    // })
    console.log({element});
    var opt ={
        margin: 1,
        filename: 'Organigrama - PPF .pdf',
        image: {type: 'jpeg', quality: 1},
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    }
    console.log({element}, element.offsetWidth, element.offsetHeight);
    toPng(element, {
        quality: 1,
        pixelRatio: 15,
        skipAutoScale: false,
        // width:  element.offsetWidth,
        // height: element.offsetHeight
    })
    .then((dataUrl) => {
        console.log('esta haciendo algo');
        console.log({dataUrl});
        const img = new Image();
        console.log({img});
        img.src = dataUrl;
        console.log({img});
        document.body.appendChild(img);


        const downloadLink = document.createElement('a');
        const fileName = 'Organigrama';
        descargarArchivo(dataUrl, downloadLink, fileName)


    })
    .then((dataUrl) =>{
    }
    
    )
    .catch((err) => {
        console.error('oops, something went wrong!', err);
    });
    // New Promise-based usage:
    // html2pdf().from(element).set(opt).save();
    setLoading(false);
}